export const BACKGROUND = "#F6FAFB";
